import styled from "styled-components";

export const Divider = styled.div<{ color: string }>`
  flex: 1;
  height: 2;
  border: 1px solid ${(props) => props.color};
`;
